<template>
  <div>
    <data-local-table
      :fields="fields"
      :items="value"
    >
    </data-local-table>
    <v-btn
      color="primary"
      small
      @click="shodAddDialog"
    >
      Add Service
    </v-btn>
    <modal-form
      title="Service"
      :show="dialog"
      @update:show="dialog=$event"
      v-on:saveData="doSave"
    >
      <v-form v-model="valid">
        <v-row>
          <v-col cols="4">
            <service-capacity
              :readonly="isReadOnly()"
              label="Service capacity"
              :value="getValue(item, 'service_capacity')"
              @input="setValue(item, 'service_capacity', $event)"
            ></service-capacity>
          </v-col>
          <v-col cols="4">
            <display-field
              label="Description"
            >Autogenerated</display-field>
          </v-col>
          <v-col cols="4">
            <service-provider
              :readonly="isReadOnly()"
              label="Service provider"
              :value="getValue(item, 'service_provider')"
              @input="setValue(item, 'service_provider', $event)"
            ></service-provider>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Service ID"
              :value="getValue(item, 'service_id')"
              @input="setValue(item, 'service_id', $event)"
            ></text-field>
          </v-col>
          <v-col cols="4">
            <date-picker
              :readonly="isReadOnly()"
              label="Service lease duration"
              :value="getValue(item, 'service_lease_duration')"
              @input="setValue(item, 'service_lease_duration', $event)"
            ></date-picker>
          </v-col>
          <v-col cols="4">
            <text-field
              :readonly="isReadOnly()"
              label="Service lease cost"
              :value="getValue(item, 'service_lease_cost')"
              @input="setValue(item, 'service_lease_cost', $event)"
            ></text-field><span>CONTACT</span>
          </v-col>
        </v-row>
      </v-form>
    </modal-form>
  </div>
</template>

<script>
  import ServiceCapacity from '@/components/codelist/ServiceCapacity'
  import DisplayField from '@/components/DisplayField'
  import ServiceProvider from '@/components/codelist/ServiceProvider'
  import TextField from '@/components/TextField'
  import DatePicker from '@/components/DatePicker'
  import ModalForm from '@/components/ModalForm'
  import DataTable from '@/components/DataTable'
  import ReactivityMixin from '@/mixins/Reactivity'
  import DataLocalTable from '@/components/DataLocalTable'
  import PermissionsMixin from '@/mixins/Permissions'
  export default {
    name: 'ServiceLists',
    components: { DataLocalTable, DataTable, ModalForm, DatePicker, TextField, ServiceProvider, DisplayField, ServiceCapacity },
    mixins: [
      ReactivityMixin,
      PermissionsMixin,
    ],
    props: {
      value: {
        default: [],
      },
      site: {},
    },
    watch: {
      value: function () {
        this.$emit('input', this.value)
      },
    },
    data: function () {
      return {
        valid: false,
        dialog: false,
        item: {},
        selected_index: -1,
        fields: [
          {
            name: 'service_id',
            title: 'Service',
          },
        ],
        section: 'transmission_equipment',
      }
    },
    computed: {
      isEditing () {
        return this.selected_index > -1
      },
    },
    methods: {
      shodAddDialog () {
        this.item = {}
        this.selected_index = -1
        this.dialog = true
      },
      doSave () {
        if (this.valid) {
          if (this.isEditing) {
            this.value[this.selected_index] = this.item
            this.dialog = false
          } else {
            this.value.push(this.item)
            this.dialog = false
          }
        }
      },
    },
  }
</script>

<style scoped>

</style>
